import '../common/base';
import Vue from './common/vue-common';
import VueRouter from 'vue-router';
import SizesGuidePage from './components/new-sizes-guide/SizesGuidePage.vue';
import SizeGuideDetails from './components/new-sizes-guide/SizeGuideDetails.vue';
import SizeGuideList from './components/new-sizes-guide/SizeGuideList.vue';

Vue.use(VueRouter);

const routes = [
    {
        name: 'home',
        path: '/',
        component: SizeGuideList,
    },
    {
        name: 'model-info',
        path: '/:modelName',
        component: SizeGuideDetails,
    },
    { path: '*', redirect: '/' },
];

const router = new VueRouter({
    mode: 'hash',
    base: '/guia-de-tamanhos',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
    routes,
});

new Vue({
    el: '#sizes-guide-page-vue',
    template: '<SizesGuidePage/>',
    components: { SizesGuidePage },
    router,
});
